import { Component, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'app-treatment',
  templateUrl: './treatment.component.html',
  styleUrls: ['./treatment.component.scss']
})
export class TreatmentComponent {
}

// <ul>
//     <li>
//         A range of treatments including medicines and behavioural therapies are effective in helping people stop heroin use. 
//         It’s important to match the best treatment approach to meet the particular needs of each individual patient.
//     </li>
//     <li>
//         There are two different approaches to stopping heroin use: maintenance therapy or detox.
//         <ul>
//             <li>
//                 <b>Maintenance therapy</b> – this allows you to switch from heroin to a heroin substitute, such as methadone or
//                 buprenorphine. You then stay on a stable dose of the substitute.
//             </li>
//             <li>
//                 <b>Detox</b> – this allows you to switch from heroin to a heroin substitute then gradually withdraw from the substitute so that
//                 you are free from both.
//             </li>
//         </ul>
//     </li>
//     <li>
//         <b>Maintenance treatments</b> 
//         <ul>
//             <li>
//                 Maintenance treatments(also called Opioid agonist treatment (OAT), or Opioid substitution therapy (OST)), involves prescription of opioid 
//                 agonists to manage craving and withdrawal syndromes, decrease drug-related harm, and improve daily functioning for the individual, 
//                 without producing euphoria. There is a strong evidence base supporting the effectiveness of OAT in reduction and cessation of illicit 
//                 drug use, the reduction of drug injecting and related blood-borne viruses, and reducing drug-driven crime. A standard OAT regimen is 
//                 likely to include an initial induction phase, a maintenance phase, and a potential phase of medically supervised withdrawal. 
//                 Relapse is common, and so many patients are likely to require multiple treatment episodes to achieve long-term improvements.
//             </li>
//             <li>
//                 Effective maintenance treatment is available in England, using commonly prescribed agonists of methadone, buprenorphine, buprenorphine/ naloxone 
//                 combinations and naltrexone. Treatment options include:
//             </li>
//         </ul>
//     </li>
//     <li>
//         <b>Buprenorphine</b> - Buprenorphine is a synthetic opioid drug that functions as a partial agonist to create a safe level of opioid effects. 
//         With this medication, effects only reach a certain point, which discourages abusing the drug to achieve the desired ‘high’. 
//         <ol>
//             <li>
//                 Buvidal ® - Long-acting buprenorphine products administered by subcutaneous injection in depot format are approved
//                 in the UK. A depot injection is a slow-release form of medication which is commonly used in other areas of medical practice. It delivers 
//                 the same medication for opioid agonist therapy (OAT), but is administered by injection, given as a carrier liquid that releases the 
//                 medication slowly for longer action. These products may offer advantages over other forms of therapy for some patients, including: less 
//                 risk of misuse and diversion; less risk of exposure in children or others in the domestic setting; reduced requirement (and associated 
//                 costs) for patients to attend treatment and disrupt daily routine.
//             </li>
//             <li>
//                 Espranor ® - Fast dissolving tablets containing buprenorphine, administrated on the tongue, under daily supervision. Espranor may provide 
//                 benefits in reducing diversion and timing of supervised doses due to its faster dissolution rate.
//             </li>
//             <li>
//                 Generic buprenorphine, Subutex® and Suboxone® – Sublingual tablets containing buprenorphine and the opioid antagonist naloxone in a combined 
//                 sublingual tablet (buprenorphine: naloxone in a ratio of 4:1).
//             </li>
//         </ol>
//     </li>
//     <li>
//         <b>Methadone</b> - Methadone is long-acting synthetic opioid agonist. It works to reduce cravings and prevents relapse by 
//         alleviating symptoms of withdrawal.
//         <ol>
//             <li>
//                 Available as an oral solution (recommended), tablet or injectable formula in various doses according to need.
//             </li>
//         </ol>
//     </li>
//     <li>
//         <b>Naltrexone</b> - Naltrexone is a synthetic opioid antagonist, which works by blocking the opioid receptors in the brain from the
//         effects of euphoria that opiates provide.
//     </li>
//     <li>
//         <b>Detoxification treatments available in the UK</b>
//         <ol>
//             <li>
//                 Methadone or buprenorphine should be offered as the first-line treatment in opioid detoxification. When 
//                 deciding between these medications, healthcare professionals should take into account:
//                 <ul>
//                     <li>
//                         whether the service user is receiving maintenance treatment with methadone or buprenorphine; if so, opioid detoxification 
//                         should normally be started with the same medication
//                     </li>
//                     <li>
//                         Service user preference
//                     </li>
//                 </ul>
//             </li>
//             <li>
//                 Lofexidine may be considered for people:
//                 <ul>
//                     <li>
//                         Who have made an informed and clinically appropriate decision not to use methadone or buprenorphine for detoxification
//                     </li>
//                     <li>
//                         Who have made an informed and clinically appropriate decision to detoxify within a short time period                    
//                     </li>
//                     <li>
//                         With mild or uncertain dependence (including young people).
//                     </li>
//                 </ul>
//             </li>
//             <li>
//                 Other options include Clonidine and Dihydrocodeine, although they should not be used routinely in opioid detoxification.
//             </li>
//         </ol>
//     </li>
// </ul>
